import { Meteor } from 'meteor/meteor';

export function callMethod(name, payload = {}) {
  return new Promise((resolve, reject) => {
    Meteor.call(name, payload, (error, result) => {
      if (error) reject(error);
      else resolve(result);
    });
  });
}
